import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { signOutCoach, useCoach, useCoachName } from "../auth";

export function Shell({ children }: { children: ReactNode }) {
    const { clubs } = useCoach();
    const name = useCoachName();
    return (
        <div className="shell">
            <header className="topbar">
                <NavLink to="/" className="brand">
                    <img src="/swana-logo.png" alt="" width={28} height={28} />
                    <span>Swana Coach</span>
                </NavLink>
                <nav>
                    <NavLink to="/" end>Dashboard</NavLink>
                    <NavLink to="/inbox">Inbox</NavLink>
                    <NavLink to="/profile">Profile</NavLink>
                </nav>
                <div className="who">
                    <span className="muted small">{name} · {clubs.map((c) => c.clubName).join(", ")}</span>
                    <button className="btn ghost small" onClick={() => void signOutCoach()}>Sign out</button>
                </div>
            </header>
            <main className="content">{children}</main>
        </div>
    );
}
